<template>
    <div class="u-text-center" v-if="loading">
        불러오는 중입니다…
    </div>
    <div v-else>
        <ul>
            <li v-for="notice of notices">
                <router-link :to="`/page/${notice.id}`">{{ notice.title }}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "PageList",
        props: ['category'],
        data() {
            return {
                request: axios.get('/data/page-list/' + this.category),
                notices: [],
                loading: true
            }
        },
        created() {
            this.request.then(response => {
                this.notices = response.data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
            });
        }
    }
</script>

<style scoped>

</style>
